import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "grid w-full py-3 px-7 sm:grid-cols-3" }

import ScorecardSection from './ScorecardSection.vue';
import InputField from '@/components/Inputs/InputField.vue';
import { useWrestlerStore } from '@/store/wrestlers';

interface Props {
  scheduleds: Array<string | number>;
}


export default /*#__PURE__*/_defineComponent({
  props: {
    scheduleds: null
  },
  setup(__props: any) {



const wrestlerStore = useWrestlerStore();

function getWrestler(raw: string | number) {
  if (!isNaN(Number(raw))) {
    const wrestler = wrestlerStore.wrestlers.find((w) => w.SuperstarId === raw);
    if (wrestler) {
      return wrestler.Name;
    }
  }
  return raw;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ScorecardSection, { title: "Scheduled Appearances" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.scheduleds, (scheduled) => {
          return (_openBlock(), _createElementBlock("div", {
            key: scheduled,
            class: "my-2"
          }, [
            _createVNode(InputField, null, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(getWrestler(scheduled)), 1)
              ]),
              _: 2
            }, 1024)
          ]))
        }), 128))
      ])
    ]),
    _: 1
  }))
}
}

})